export default function CompaniesState (state = {
    companies: { search_string: '', list:{}, details:{}, validation:{}, options:{}}
    }, action) {
    switch(action.type) {
        case 'COMPANIES_UPDATE_SEARCH_STRING':
            state.companies.search_string = action.value;
        return { ...state };
        case 'COMPANIES_SEARCH':
            state.companies.list = action.data.list;
            return { ...state };
        case 'COMPANIES_OPTIONS':
            state.companies.options = action.data.options;
            return { ...state };
        case 'COMPANIES_DETAILS':
            state.companies.details = action.data.record;
            return { ...state };
        case 'COMPANIES_UPDATE_FORM':
            state.companies.details[action.field] = action.value;
            if (state.companies.validation[action.field]) {
                state.companies.validation[action.field] = {};
            }
            return { ...state };
        case 'COMPANIES_VALIDATION_ERROR':
            state.companies.validation = action.data;
            return { ...state };
        case 'COMPANIES_SELECTED':
            state.companies.selected = action.value;
            state.companies.details = {};
            state.companies.validation = {};
            return { ...state };
        case 'COMPANIES_DESELECTED':
        case 'COMPANIES_UPDATED':
        case 'COMPANIES_INSERTED':
        case 'COMPANIES_DELETED':
            state.companies.selected = null;
            state.companies.details = {};
            state.companies.validation = {};
            return { ...state };
        case 'COMPANIES_CANCEL_SELECT':
            state.companies.selected = null;
            return { ...state };
        case 'COMPANIES_INSERT_ERROR':
        case 'COMPANIES_UPDATE_ERROR':
            state.companies = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

